import React, { useEffect, useState } from 'react'
import { useAuth } from '../../../AuthProvider';
import { getUsageSummary } from '../../../api/apiClient';
import { Eraser, Crown, Maximize, Layout, Wand2 } from "lucide-react";

export const Usage = () => {

    const [usageLoading, setUsageLoading] = useState(true);
    const [usageError, setUsageError] = useState(null);
    const [usageData, setUsageData] = useState({
      plan: "Free",
      usage: {
        background_remover: 0,
        image_upscale: 0,
        image_expansion: 0,
        ai_model: 0,
      },
      limits: {
        limit: 0,
        period: "month"
      },
    });

    const { currentUser } = useAuth();
    

    const fetchUsageSummary = async () => {
        try {
          if (!currentUser) return;
    
          const headers = {
            Authorization: `Bearer ${await currentUser.getIdToken()}`,
            "X-User-Id": currentUser.uid,
          };
    
          const response = await getUsageSummary(headers);
    
          if (response.data && response.data.usage) {
            setUsageData(response.data.usage);
          } else {
            throw new Error("Invalid response structure");
          }
          setUsageLoading(false);
        } catch (err) {
          console.error("Error fetching usage summary:", err);
          setUsageError(err.message || "Failed to load usage data");
          setUsageLoading(false);
        }
      };

       useEffect(() => {
          fetchUsageSummary();
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [currentUser]);

  return (
    <>
    <div className="bg-white rounded-lg shadow p-6 mb-6">
                  <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-medium">Your Usage</h2>
                    <div className="flex items-center">
                      <Crown size={16} className="mr-1 text-yellow-500" />
                      <span className="text-sm font-medium text-gray-700">
                        {usageData.plan} Plan
                      </span>
                    </div>
                  </div>

                  {usageLoading ? (
                    <div className="flex justify-center items-center py-4">
                      <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-400"></div>
                    </div>
                  ) : usageError ? (
                    <div className="text-center py-4 text-red-500">
                      {usageError}
                    </div>
                  ) : usageData ? (
                    <div className="space-y-4">
                      {/* Background Removals */}
                      {usageData.usage.background_remover > 0 && (
                      <div>
                        <div className="flex justify-between text-sm">
                          <span className="flex items-center">
                            <Eraser
                              size={16}
                              className="mr-1 text-purple-500"
                            />
                            Background Removals
                          </span>
                          <span className="font-medium">
                            {usageData.usage.background_remover}
                          </span>
                        </div>
                      </div>
                      )}

                      {/* Image Upscales */}
                      {usageData.usage.image_upscale > 0 && (
                      <div>
                        <div className="flex justify-between text-sm">
                          <span className="flex items-center">
                            <Maximize
                              size={16}
                              className="mr-1 text-blue-500"
                            />
                            Image Upscales
                          </span>
                          <span className="font-medium">
                            {usageData.usage.image_upscale}
                          </span>
                        </div>
                      </div>
                      )}

                      {/* Image Expansions */}
                      {usageData.usage.image_expansion > 0 && (
                      <div>
                        <div className="flex justify-between text-sm">
                          <span className="flex items-center">
                            <Layout size={16} className="mr-1 text-green-500" />
                            Image Expansions
                          </span>
                          <span className="font-medium">
                            {usageData.usage.image_expansion}
                          </span>
                        </div>
                      </div>
                      )}

                      {/* Ai Model */}
                      {usageData.usage.ai_model > 0 && (
                      <div>
                        <div className="flex justify-between text-sm">
                          <span className="flex items-center">
                            <Wand2 size={16} className="mr-1 text-orange-500" />
                            Ai Models
                          </span>
                          <span className="font-medium">
                            {usageData.usage.ai_model}
                          </span>
                        </div>
                      </div>
                      )}
                    </div>
                  ) : null}

                  {/* Total Usage Summary */}
                  <div className="mt-6 pt-4 border-t border-gray-100">
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-sm font-medium text-gray-700">
                        Total Generations Used
                      </span>
                      <span className="text-lg font-bold text-gray-900">
                        {usageData.usage.total || 0}
                      </span>
                    </div>
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-sm text-gray-600">
                        {usageData.limits.period?.charAt(0).toUpperCase() + usageData.limits.period.slice(1)} Limit
                      </span>
                      <span className="text-sm font-medium text-gray-700">
                        {usageData.limits.limit}
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-600">
                        Available Generations
                      </span>
                      <span className="text-sm font-medium text-green-600">
                        {Math.max(0, (usageData.limits.limit - (usageData.usage.total || 0)))}
                      </span>
                    </div>
                  </div>

                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <p className="text-sm text-gray-500">
                      Usage resets {usageData.limits.period}
                    </p>
                  </div>
                </div>
    </>
  )
}
